import React from "react";
import { motion } from "framer-motion";

const Founder = () => {
  return (
    <section
      data-testid="founder-section"
      className="relative py-28 md:py-36 bg-white"
    >
      <div className="mx-auto max-w-5xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-[36px] border border-zinc-200 bg-gradient-to-br from-zinc-50 via-white to-white p-10 md:p-16 overflow-hidden"
        >
          <div className="absolute -top-24 -right-24 w-96 h-96 glow-blue blur-3xl opacity-40" />

          <div className="relative grid md:grid-cols-[auto,1fr] gap-10 md:gap-14 items-center">
            {/* Avatar — shaped like the VoloTag device */}
            <div className="relative shrink-0">
              <div className="relative w-36 h-36 md:w-44 md:h-44">
                {/* Halo */}
                <div className="absolute inset-0 glow-blue blur-2xl opacity-40" />
                <svg viewBox="0 0 200 200" className="relative w-full h-full drop-shadow-[0_30px_50px_rgba(15,23,42,0.35)]">
                  <defs>
                    <linearGradient id="avatar-body" x1="0" y1="0" x2="1" y2="1">
                      <stop offset="0%" stopColor="#1F1F22" />
                      <stop offset="60%" stopColor="#0A0A0A" />
                      <stop offset="100%" stopColor="#050507" />
                    </linearGradient>
                    <linearGradient id="avatar-shine" x1="0" y1="0" x2="1" y2="1">
                      <stop offset="0%" stopColor="rgba(255,255,255,0.35)" />
                      <stop offset="50%" stopColor="rgba(255,255,255,0)" />
                    </linearGradient>
                  </defs>
                  {/* Pebble body — same silhouette as the device */}
                  <path
                    d="M100 18 C 148 18, 186 46, 186 100 C 186 154, 148 182, 100 182 C 52 182, 14 154, 14 100 C 14 46, 52 18, 100 18 Z"
                    fill="url(#avatar-body)"
                  />
                  {/* V notch — same signature as device */}
                  <path
                    d="M85 17 L100 33 L115 17"
                    stroke="#3B82F6"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  {/* Gloss */}
                  <path
                    d="M36 58 C 68 36, 100 32, 130 40"
                    stroke="url(#avatar-shine)"
                    strokeWidth="10"
                    strokeLinecap="round"
                    fill="none"
                  />
                  {/* Monogram */}
                  <text
                    x="100"
                    y="118"
                    textAnchor="middle"
                    fill="#FAFAFA"
                    fontFamily="Outfit, sans-serif"
                    fontWeight="600"
                    fontSize="56"
                    letterSpacing="-2"
                  >
                    YA
                  </text>
                </svg>
              </div>
              <div className="mt-5 text-center md:text-left">
                <div className="font-display text-base font-semibold tracking-tight">Yaser Atarud</div>
                <div className="text-xs text-zinc-500 mt-0.5">Founder · VoloTag</div>
              </div>
            </div>

            <div>
              <p className="text-xs tracking-[0.22em] uppercase text-blue-600 font-medium">A Founder's Note</p>
              <blockquote className="mt-5 font-display text-2xl md:text-[32px] leading-[1.15] tracking-tight text-zinc-900">
                "I didn't want to build another silent tracker.
                <span className="block mt-2 text-zinc-500">
                  I wanted something that <span className="italic text-zinc-900">answers</span> when you call."
                </span>
              </blockquote>
              <p className="mt-6 text-zinc-600 leading-relaxed max-w-xl">
                VoloTag started as a small idea: what if the things we lose could feel
                a little alive — calm, familiar, ready to reply? That's the whole mission.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Founder;
